import { VContainer } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VLayout,[(_vm.isMobile)?_c(VContainer,[_c('v20a6000m',{attrs:{"route-name":_vm.$route.name+'m'}})],1):_c(VContainer,[_c('v20a6000pc',{attrs:{"route-name":_vm.$route.name+'pc'}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }